export default __webpack_public_path__ + "static/media/permit_map_marker.9a36dfbb.svg";